import { Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import _slicedToArray from "/usr/src/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";

/** @jsxImportSource @emotion/react */
import { Typography } from "@vc-workspace/utils-typography";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import CircleIcon from '@mui/icons-material/Circle';
import Divider from '@mui/material/Divider';
import { containerStyles, quesIndicator, ansStyles } from './maker-faq.module.style';
import React from "react";
export function MakerFaq(props) {
  var _React$useState = React.useState(0),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      expanded = _React$useState2[0],
      setExpanded = _React$useState2[1];

  var handleChange = function handleChange(panel) {
    return function (event, isExpanded) {
      setExpanded(isExpanded ? panel : false);
    };
  };

  return _jsx("div", {
    css: containerStyles,
    children: _jsxs("div", {
      className: "page-container pure-g",
      children: [_jsx("div", {
        className: props.context.isMobileView ? "pure-u-1" : "pure-u-1-5",
        children: _jsxs(Typography, {
          type: props.context.isMobileView ? "Headline_H1" : "Heading2",
          color: "night_rider",
          bold: true,
          children: ["Frequently ", _jsx("br", {}), "Asked", _jsx("br", {}), " Questions"]
        })
      }), _jsx("div", {
        className: props.context.isMobileView ? "pure-u-1 pt-4" : "pure-u-4-5",
        children: FAQ.map(function (faqItem, index) {
          return _jsxs(_Fragment, {
            children: [_jsxs(Accordion, {
              expanded: expanded === index,
              onChange: handleChange(index),
              sx: {
                background: 'transparent',
                boxShadow: 'none'
              },
              children: [_jsxs(AccordionSummary, {
                id: faqItem.title,
                children: [_jsx(Typography, {
                  type: "SubHeading1",
                  color: "purple_heart",
                  custom_style: quesIndicator,
                  children: _jsx(CircleIcon, {
                    sx: {
                      width: '10px !important'
                    }
                  })
                }), _jsx(Typography, {
                  type: "SubHeading1",
                  color: "nero",
                  bold: true,
                  children: faqItem.title
                })]
              }), _jsx(AccordionDetails, {
                children: _jsx("div", {
                  css: ansStyles,
                  children: faqItem.content
                })
              })]
            }), _jsx(Divider, {})]
          });
        })
      })]
    })
  });
}
var FAQ = [{
  title: 'What can I sell on Vibecity?',
  content: _jsxs(_Fragment, {
    children: [_jsxs(Typography, {
      type: "SubHeading1",
      color: "nero",
      children: ["You can sell ", _jsx("b", {
        children: "only handmade products"
      }), " from lifestyle categories such as clothing, footwear accessories, jewellery, food, beauty, art, home decor and furnishing."]
    }), _jsxs(Typography, {
      type: "SubHeading1",
      color: "nero",
      className: "pt-2",
      children: ["Vibecity ", _jsx("b", {
        children: "doesn't allow"
      }), " sellers"]
    }), _jsxs("ul", {
      className: "pt-1 list-disc ml-5",
      children: [_jsx("li", {
        children: "Who sell mass-merchandise or factory made items"
      }), _jsx("li", {
        children: "Who sell or resell branded products"
      })]
    })]
  })
}, {
  title: 'How can I list my product on Vibecity?',
  content: _jsxs(_Fragment, {
    children: [_jsx(Typography, {
      type: "SubHeading1",
      color: "nero",
      children: "Listing on Vibecity is a simple process:"
    }), _jsxs("ul", {
      className: "pt-1 list-disc ml-5",
      children: [_jsx("li", {
        children: "Once you have logged in to the seller app or web dashboard, complete your shop setup by entering your details"
      }), _jsx("li", {
        children: "Select \"Add Product\" to upload all details for a product to get listed on your Vibecity Shop"
      }), _jsx("li", {
        children: "Each listing is reviewed before it is listed on the marketplace & starts getting traffic"
      })]
    })]
  })
}, {
  title: 'What are the charges for selling on Vibecity?',
  content: _jsxs(_Fragment, {
    children: [_jsx(Typography, {
      type: "SubHeading1",
      color: "nero",
      children: "Vibecity has a very seller friendly model for commissions:"
    }), _jsxs("ul", {
      className: "pt-1 list-disc ml-5",
      children: [_jsx("li", {
        children: "We charge a simple 3% Service Charge on each order. This is a nominal charge to cover for the costs of enabling online shopping."
      }), _jsx("li", {
        children: "Beyond that, we charge a 12% Referral Charge ONLY for the customers we get you and 6% when they reorder from you"
      })]
    }), _jsx(Typography, {
      type: "SubHeading1",
      color: "nero",
      className: "pt-4",
      children: "Vibecity offers a free of cost shop setup to all our sellers. Only the service charge will apply for your customers per order."
    })]
  })
}, {
  title: 'How will I get paid for my orders?',
  content: _jsx(_Fragment, {
    children: _jsx(Typography, {
      type: "SubHeading1",
      color: "nero",
      children: "Your earnings from an order will be credited to your wallet right after order is delivered. The amount in your wallet is paid out to your bank account daily, pending seller KYC is approved."
    })
  })
}, {
  title: 'How will I receive my orders?',
  content: _jsxs(Typography, {
    type: "SubHeading1",
    color: "nero",
    children: ["You can receive, ship and track all your orders from the ", _jsx("b", {
      children: "My Orders"
    }), " section of the seller app. Please download the app to get started and stay updated with your operations."]
  })
}, {
  title: 'How will I ship my orders?',
  content: _jsxs(_Fragment, {
    children: [_jsxs(Typography, {
      type: "SubHeading1",
      color: "nero",
      children: ["We provide easy and intelligent ", _jsx("b", {
        children: "Vibecity shipping"
      }), " solutions. We have tied up with 20+ shipping partners such as ", _jsx("b", {
        children: "Delhivery, Bluedart, Ekart, Xpressbees etc"
      }), " to fulfil pan-India orders."]
    }), _jsxs(Typography, {
      type: "SubHeading1",
      color: "nero",
      className: "pt-2",
      children: ["We internally allocate orders to courier partners to provide ", _jsx("b", {
        children: "fastest possible deliveries at the cheapest rates"
      }), " in the industry. Vibecity shipping offers simple and easy one touch home pick-up scheduling from the seller app."]
    })]
  })
}];
export default MakerFaq;